import React, { useState } from 'react';
import axios from 'axios';
import ReactLoading from 'react-loading';
import Pagination from './Pagination';
import Card from './Card';
import moment from 'moment';
import DatePicker from 'react-datepicker';

class Events extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			error: null,
			isLoadedLibrary: false,
			isLoadedFilters: false,
			isLoadedContent: false,
			mainClass: 'hide',
			queryParams: {},
			filters: [],
			items: [],
			pagination: {},
			filtersHidden: true,
			sticky: {},
		};

		this.filterCloseButton = React.createRef();
		this.filterOpenButton = React.createRef();

		this.handleSingleFilter = this.handleSingleFilter.bind(this);
		this.toggleFilters = this.toggleFilters.bind(this);
		this.filterItems = this.filterItems.bind(this);
		this.handlePage = this.handlePage.bind(this);
		this.escFunction = this.escFunction.bind(this);
	}

	escFunction(event) {
		if (event.key === "Escape") {
			this.setState(
				{
					filtersHidden: true
				},
				() => {
					setTimeout(() => {
						this.filterOpenButton.current.focus();
					}, 100);
				}
			);
		}
	}

	componentDidMount() {
		document.addEventListener("keydown", this.escFunction, false);

		// Prepopulate queryParams in this.state with URL query params.
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const urlParamsEntries = urlParams.entries();

		const defaultQueryParams = {};

		for (const item of urlParamsEntries) {
			if (item[1].length > 0) {
				if('start' === item[0] || 'end' === item[0]) {
					defaultQueryParams[item[0]] = item[1];
				} else {
					if (item[1].includes(',')) {
						// Arrays need to be converted from "x,y" to [x,y].
						defaultQueryParams[item[0]] = item[1].split(',');
					} else {
						// Array with one item.
						defaultQueryParams[item[0]] = [item[1]];
					}
				}
			}
		}

		// Set the default state and afterwards, fetch data.
		this.setState(
			{
				queryParams: defaultQueryParams,
			},
			() => {
				this.fetchFilters();
				this.fetchData();
			}
		);
	}

	componentWillUnmount() {
		document.removeEventListener("keydown", this.escFunction, false);

		{
			/* eslint-disable no-useless-return */
		}
		this.setState = () => {
			return;
		};
	}

	fetchFilters() {
		// Get the taxonomy data for the dropdown and checkbox filters.
		const fetchUrl = new URL(
			'/wp-json/northlandcollege/v1/events/filters',
			window.location.protocol + window.location.hostname
		);

		axios
			.get(fetchUrl)
			.then((response) => {
				this.setState(
					{
						filters: response.data,
					},
					() => {
						this.updateSelectedFilters(this.state.queryParams);
					}
				);
			})
			.catch((error) => {
				this.setState({
					isLoadedFilters: false,
					error,
				});
			});
	}

	updateSelectedFilters(newFilters) {
		const filters = this.state.filters;

		// Clear filters.
		for (let [key, value] of Object.entries(filters)) {
			filters[key] = filters[key].map((item, index) => {
				if (item.selected) {
					delete item.selected
				}
				return item;
			})
		}

		// Add selected to filters.
		for (let [key, value] of Object.entries(newFilters)) {
			if (filters && filters.hasOwnProperty(key) && Array.isArray(value)) {
				filters[key] = filters[key].map((item, index) => {
					if (value.includes(item.key)) {
						item.selected = true;
					}
					return item;
				})
			}
		}

		this.setState({
			filters,
			isLoadedFilters: true,
		})
	}

	fetchData() {
		const fetchUrl = new URL(
			'/wp-json/northlandcollege/v1/events',
			window.location.protocol + window.location.hostname
		);

		// Populate both the parameters for the REST request and for
		// updating the URL.
		const urlParams = [];

		if (this.state.queryParams !== {}) {
			Object.keys(this.state.queryParams).forEach((key) => {
				const value = this.state.queryParams[key];
				if (Array.isArray(value) && value.length > 0) {
					// Don't include search if it's empty.
					if ('events-search' === key && '' === value[0]) {
						return;
					}

					// Arrays need to be converted from [x,y] to "x,y".
					fetchUrl.searchParams.append(key, value.join(','));
					urlParams.push([key, value.join(',')].join('='));
				} else {
					fetchUrl.searchParams.append(key, value);
					const tmpValue = value + '';

					if (!! value && tmpValue.length > 0 && tmpValue !== '0') {
						urlParams.push([key, value].join('='));
					}
				}
			});
		}

		// Update the URL with GET parameters.
		if (urlParams.length > 0) {
			const urlUpdate = '?' + urlParams.join('&');
			history.pushState(this.state.queryParams, '', urlUpdate);
		} else {
			history.pushState(
				this.state.queryParams,
				'',
				window.location.pathname
			);
		}

		axios.get(fetchUrl).then(
			(response) => {
				// Successfully got results.
				this.setState({
					isLoadedLibrary: true,
					isLoadedContent: true,
					items: response.data.posts,
					sticky: response.data.sticky,
					pagination: response.data.pagination,
					mainClass: 'show',
				});
			},
			(error) => {
				// Error getting results.
				this.setState({
					isLoadedLibrary: false,
					isLoadedContent: false,
					error,
				});
			}
		);
	}

	// Process select and search filters on keydown.
	handleSingleFilter(event) {
		if ('Enter' === event.key || 'Return' === event.key) {
			this.setState(
				(state) => ({
					isLoadedContent: false,
					isLoadedLibrary: false,
					queryParams: {
						...state.queryParams,
						[event.target.id]: event.target.value.split(","),
					},
				}),
				() => {
					this.updateSelectedFilters(this.state.queryParams);
					this.fetchData();
				}
			);
		}
	}

	handlePage(event) {
		// Update the page and fetch new data for pagination.
		event.preventDefault();

		const page = event.target.value > 1 ? event.target.value : 0;

		this.setState(
			(state) => ({
				isLoadedContent: false,
				isLoadedLibrary: false,
				queryParams: {
					...state.queryParams,
					pg: page,
				},
			}),
			() => {
				this.updateSelectedFilters(this.state.queryParams);
				this.fetchData();
			}
		);
	}

	toggleFilters(event) {
		this.setState(
			(state) => ({
				filtersHidden: ! this.state.filtersHidden
			}),
			() => {
				setTimeout(() => {
					if (!this.state.filtersHidden) {
						this.filterCloseButton.current.focus();
					} else {
						this.filterOpenButton.current.focus();
					}
				}, 100);
			}
		);
	}

	// Update the current selected items in the filters.
	filterItems(newFilters, toggleFilters = null) {
		this.updateSelectedFilters(newFilters);

		let filtersHidden = !this.state.filtersHidden;
		if (false === toggleFilters) {
			filtersHidden = true;
		}
		if (true === toggleFilters) {
			filtersHidden = false;
		}

		this.setState(
			(state) => ({
				filtersHidden,
				isLoadedContent: false,
				isLoadedLibrary: false,
				queryParams: {
					...state.queryParams,
					campuses: newFilters.campuses,
					experiences: newFilters.experiences,
					topics: newFilters.topics,
					audiences: newFilters.audiences,
					event_types: newFilters.event_types,
					start: newFilters.start,
					end: newFilters.end,
				},
				items: [],
			}),
			() => {
				this.fetchData();
			}
		);
	}

	removeFilter(category, key) {
		const filterIndex = this.state.queryParams[category].indexOf(key);
		const queryParamCategoryCopy = this.state.queryParams[category].slice();
		queryParamCategoryCopy.splice(filterIndex, 1);

		const newFilters = {
			campuses: [],
			experiences: [],
			topics: [],
			audiences: [],
			event_types: [],
			start: '',
			end: '',
		}

		if (this.state.queryParams['campuses']) {
			newFilters.campuses = this.state.queryParams['campuses'];
		}
		if (this.state.queryParams['experiences']) {
			newFilters.experiences = this.state.queryParams['experiences'];
		}
		if (this.state.queryParams['topics']) {
			newFilters.topics = this.state.queryParams['topics'];
		}
		if (this.state.queryParams['audiences']) {
			newFilters.audiences = this.state.queryParams['audiences'];
		}
		if (this.state.queryParams['event_types']) {
			newFilters.event_types = this.state.queryParams['event_types'];
		}
		if (this.state.queryParams['start']) {
			newFilters.start = this.state.queryParams['start'];
		}
		if (this.state.queryParams['end']) {
			newFilters.end = this.state.queryParams['end'];
		}

		if ('campuses' === category) {
			newFilters.campuses = queryParamCategoryCopy;
		}
		if ('experiences' === category) {
			newFilters.experiences = queryParamCategoryCopy;
		}
		if ('topics' === category) {
			newFilters.topics = queryParamCategoryCopy;
		}
		if ('audiences' === category) {
			newFilters.audiences = queryParamCategoryCopy;
		}
		if ('event_types' === category) {
			newFilters.event_types = queryParamCategoryCopy;
		}
		if ('start' === category) {
			newFilters.start = queryParamCategoryCopy;
		}
		if ('end' === category) {
			newFilters.end = queryParamCategoryCopy;
		}

		this.filterItems(newFilters, false);
	}

	render() {
		const {
			error,
			isLoadedFilters,
			isLoadedLibrary,
			isLoadedContent,
			items,
			filters,
			pagination,
			sticky,
			filtersHidden
		} = this.state;

		if (error) {
			return <div>Error: { error.message }</div>;
		}

		const defaultExperience = '';
		const defaultTopic = '';
		const defaultEventType = '';
		const defaultAudience = '';

		// Flat list for creating the filter pills.
		const filterFlatList = [];
		for (let [key, value] of Object.entries(this.state.queryParams)) {
			if (filters && filters.hasOwnProperty(key) && 'events-search' !== key && value.length > 0) {
				for (let item of value) {
					const filterValue = filters[key].filter(x => item === x.key);
					let filterName = '';
					if (filterValue.length > 0 &&  filterValue[0].hasOwnProperty('value')) {
						filterName = filterValue[0].value;
					}
					filterFlatList.push({
						key: item,
						name: filterName,
						category: key,
					});
				}
			}
		}

		const hasResults = items.length > 0 ? true : false;

		const results = items.map((item) => (
			<Card post={ item } key={ item.ID } type="event" />
		));

		const noResults = <h2 className="no-results">No events found with those filters</h2>;

		const defaultSearch = this.state.queryParams['events-search'] || '';

		let hasQueryParams = false;

		if (
			this.state.queryParams &&
			Object.keys(this.state.queryParams).length > 0
		) {
			for (const name in this.state.queryParams) {
				if (this.state.queryParams[ name ]) {
					hasQueryParams = true;
				}
			}
		}

		const filtersOverlay = this.state.filtersHidden
			? ''
			: 'filters-overlay--visible';

		return (
			<>
				<section className="news-search-filter">
					<h2 className="visually-hidden">
						Events search and filter
					</h2>
					<div className="search-filter-wrapper">
						<div className="search-wrapper">
							<label
								className="visually-hidden"
								htmlFor="events-search"
							>
								Search events
							</label>
							<input
								type="search"
								id="events-search"
								defaultValue={ defaultSearch }
								className="search form-control"
								placeholder="Search events"
								onKeyDown={ this.handleSingleFilter }
								autoComplete="off"
							/>
						</div>
						<div className="filter-wrapper">
							{isLoadedFilters ? (
								<button
									className="filters"
									aria-label="Filter"
									aria-expanded={ filtersHidden ? false : true }
									onClick={ this.toggleFilters }
									ref={this.filterOpenButton}
								>
									<span>Filters</span>
								</button>
							) : null}
						</div>
					</div>
				</section>
				<div className="program-results">
					<div className="program-results-filters">
						{isLoadedFilters && filterFlatList.length > 0 ? filterFlatList.map(item => (
							<div className="results-filter-pill" key={ item.key }>
								<div>{ item.name }</div>
								<button className="pill-close" onClick={() => this.removeFilter(item.category, item.key)} data-key={ item.key } value={`Remove ${ item.name } filter`}></button>
							</div>
						)) : null}
					</div>
					{isLoadedLibrary && isLoadedFilters ? (
						<div className="program-results-count">{ items.length } Results</div>
					) : null}
				</div>

				{isLoadedContent && this.state.sticky && ! hasQueryParams ? (
					<section className="news-media-text-block">
						<div className="row news-row">
							<div className="column text-left">
								{ sticky.post_title ? (
									<h2>{ sticky.post_title }</h2>
								) : (
									''
								) }

								{ sticky.post_title ? (
									<p>{ sticky.preview }</p>
								) : (
									''
								) }
								<ul className="sticky-list">
									<li>
										<a href={ sticky.link }>
											<img
												className="card-icon"
												src="/assets/themes/northlandcollege/images/right-arrow.svg"
												alt={ `Go to post ${ sticky.post_title }` }
											/>
										</a>
									</li>
									<li className="read-more">
										<a href={ sticky.link }>Read more</a>
									</li>
								</ul>
							</div>
							<div className="column media-right">
								<img
									className="cover-image"
									src={ sticky.thumbnail }
									alt={ sticky.thumbnail_alt }
								/>
							</div>
						</div>
					</section>
				) : null}

				{isLoadedContent ? (
					<section className="program-grid-wrapper">
						<div className="northland-card">
							<h2 className="visually-hidden">Events list</h2>
							<div className="row" aria-live="polite">
								{ hasResults ? results : noResults }
							</div>
						</div>
					</section>
				) : (
					<div className="loading product-gallery-loading">
						<ReactLoading
							type="bars"
							color="#aaa"
							height="40px"
							width="40px"
						/>
					</div>
				)}

				<Pagination
					pagination={ pagination }
					handlePage={ this.handlePage }
					pg={ this.state.queryParams.pg }
					contentLoaded={ this.state.isLoadedContent }
				/>
				{isLoadedFilters ? (
					<>
						<Filters
							hidden={ this.state.filtersHidden }
							onClose={ this.toggleFilters }
							onFilter={ this.filterItems }
							filters={ this.state.filters }
							itemsCount={ this.state.items.length }
							queryParams={ this.state.queryParams }
							filtersLoaded={ isLoadedLibrary && isLoadedFilters }
							filterCloseButton={ this.filterCloseButton }
						/>
						<div className={ `filters-overlay ${ filtersOverlay }` }></div>
					</>
				) : null}
			</>
		);
	}
}

// Handle the click of a checkbox or a date input.
function Filters(props) {
	const handleFilter = (category, key, value) => {
		// Setting defaults.
		const newFilters = {
			campuses: [],
			experiences: [],
			topics: [],
			audiences: [],
			event_types: [],
			start: '',
			end: '',
		}

		// Get current state.
		if (props.queryParams.hasOwnProperty('campuses') && props.queryParams.campuses !== 'undefined') {
			newFilters.campuses = props.queryParams.campuses;
		}
		if (props.queryParams.hasOwnProperty('experiences') && props.queryParams.experiences !== 'undefined') {
			newFilters.experiences = props.queryParams.experiences;
		}
		if (props.queryParams.hasOwnProperty('topics') && props.queryParams.topics !== 'undefined') {
			newFilters.topics = props.queryParams.topics;
		}
		if (props.queryParams.hasOwnProperty('audiences') && props.queryParams.audiences !== 'undefined') {
			newFilters.audiences = props.queryParams.audiences;
		}
		if (props.queryParams.hasOwnProperty('event_types') && props.queryParams.event_types !== 'undefined') {
			newFilters.event_types = props.queryParams.event_types;
		}
		if (props.queryParams.hasOwnProperty('start') && props.queryParams.start !== 'undefined') {
			newFilters.start = props.queryParams.start;
		}
		if (props.queryParams.hasOwnProperty('end') && props.queryParams.end !== 'undefined') {
			newFilters.end = props.queryParams.end;
		}

		// Update current filter.
		if (newFilters.hasOwnProperty(category)) {
			if ('start' === category || 'end' === category) {
				// Handle dates.
				if ('' !== value && null !== value) {
					newFilters[category] = moment(value).format('YYYY-MM-DD');
				} else {
					newFilters[category] = '';
				}
			} else {
				// Handle checkboxes.
				if (true === value) {
					if (!newFilters[category].includes(key)) {
						newFilters[category].push(key);
					}
				} else {
					if (newFilters[category].includes(key)) {
						const filterIndex = newFilters[category].indexOf(key);
						newFilters[category].splice(filterIndex, 1)
					}
				}
			}
		}

		props.onFilter(newFilters, true);
	}

	const filtersHidden = props.hidden ? 'filters-panel--hidden' : '';

	const clearAll = () => {
		const newFilters = {
			campuses: [],
			event_types: [],
			audiences: [],
			experiences: [],
			topics: [],
			start: '',
			end: '',
		};

		props.onFilter(newFilters, true);
	};

	return (
		<aside
			className={ `filters-panel ${ filtersHidden }` }
			id="filters"
			aria-label="Program Search Filters"
		>
			<div className="heading">
				<h2>Filters</h2>
				<button
					aria-label="Close filters"
					className="close"
					onClick={ props.onClose }
					autoFocus
					ref={props.filterCloseButton}
				></button>
			</div>
			<div className="filters-wrapper">
				<div className="accordion accordion-flush">
					<div className="accordion-item">
						<h3 className="accordion-header" id="filter-heading-0">
							<button
								className="accordion-button collapsed"
								type="button"
								data-bs-toggle="collapse"
								data-bs-target="#filter-collapse-0"
								aria-expanded="false"
								aria-controls="filter-collapse-0"
							>
								When
							</button>
						</h3>
						<div
							id="filter-collapse-0"
							className="accordion-collapse collapse"
							aria-labelledby="filter-heading-0"
						>
							<div className="accordion-body">
								<div className="date-field">
									<label>
										Start Date
										<DatePicker
											selected={props.queryParams.start
												? moment(props.queryParams.start, 'YYYY-MM-DD').toDate()
												: null}
											onChange={(date) => handleFilter('start', 'start', date)}
											selectsStart
											startDate={props.queryParams.start
												? moment(props.queryParams.start, 'YYYY-MM-DD').toDate()
												: null}
											endDate={props.queryParams.end
												? moment(props.queryParams.end, 'YYYY-MM-DD').toDate()
												: null}
										/>
									</label>
								</div>
								<div className="date-field">
									<label>
										End Date
										<DatePicker
											selected={props.queryParams.end
												? moment(props.queryParams.end, 'YYYY-MM-DD').toDate()
												: null}
											onChange={(date) => handleFilter('end', 'end', date)}
											selectsEnd
											startDate={props.queryParams.start
												? moment(props.queryParams.start, 'YYYY-MM-DD').toDate()
												: null}
											endDate={props.queryParams.end
												? moment(props.queryParams.end, 'YYYY-MM-DD').toDate()
												: null}
											minDate={props.queryParams.start
												? moment(props.queryParams.start, 'YYYY-MM-DD').toDate()
												: null}
										/>
									</label>
								</div>
							</div>
						</div>
					</div>
					<div className="accordion-item">
						<h3 className="accordion-header" id="filter-heading-1">
							<button
								className="accordion-button collapsed"
								type="button"
								data-bs-toggle="collapse"
								data-bs-target="#filter-collapse-1"
								aria-expanded="false"
								aria-controls="filter-collapse-1"
							>
								Experience
							</button>
						</h3>
						<div
							id="filter-collapse-1"
							className="accordion-collapse collapse"
							aria-labelledby="filter-heading-1"
						>
							<div className="accordion-body">
								{props.filters.experiences.map(
									(item, index) => (
										<div
											className="form-check"
											key={ item.key }
										>
											<label className="form-check-label">
												<input
													className="form-check-input"
													type="checkbox"
													checked={ item.selected ? true : false }
													value={ item.key }
													onChange={ () => handleFilter('experiences', item.key, !item.selected) }
												/>
												{ item.value }
											</label>
										</div>
									)
								)}
							</div>
						</div>
					</div>
				</div>
				<div className="accordion accordion-flush">
					<div className="accordion-item">
						<h3
							className="accordion-header"
							id="filter-heading-2"
						>
							<button
								className="accordion-button collapsed"
								type="button"
								data-bs-toggle="collapse"
								data-bs-target="#filter-collapse-2"
								aria-expanded="false"
								aria-controls="filter-collapse-2"
							>
								Event Type
							</button>
						</h3>
						<div
							id="filter-collapse-2"
							className="accordion-collapse collapse"
							aria-labelledby="filter-heading-2"
						>
							<div className="accordion-body">
								{props.filters.event_types.map(
									(item, index) => (
										<div
											className="form-check"
											key={ item.key }
										>
											<label className="form-check-label">
												<input
													className="form-check-input"
													type="checkbox"
													checked={ item.selected ? true : false }
													value={ item.key }
													onChange={ () => handleFilter('event_types', item.key, !item.selected) }
												/>
												{ item.value }
											</label>
										</div>
									)
								)}
							</div>
						</div>
					</div>
				</div>
				<div className="accordion accordion-flush">
					<div className="accordion-item">
						<h3
							className="accordion-header"
							id="filter-heading-3"
						>
							<button
								className="accordion-button collapsed"
								type="button"
								data-bs-toggle="collapse"
								data-bs-target="#filter-collapse-3"
								aria-expanded="false"
								aria-controls="filter-collapse-3"
							>
								Event by Audience
							</button>
						</h3>
						<div
							id="filter-collapse-3"
							className="accordion-collapse collapse"
							aria-labelledby="filter-heading-3"
						>
							<div className="accordion-body">
								{props.filters.audiences.map(
									(item, index) => (
										<div
											className="form-check"
											key={ item.key }
										>
											<label className="form-check-label">
												<input
													className="form-check-input"
													type="checkbox"
													checked={ item.selected ? true : false }
													value={ item.key }
													onChange={ () => handleFilter('audiences', item.key, !item.selected) }
												/>
												{ item.value }
											</label>
										</div>
									)
								) }
							</div>
						</div>
					</div>
				</div>
				<div className="accordion accordion-flush">
					<div className="accordion-item">
						<h3
							className="accordion-header"
							id="filter-heading-4"
						>
							<button
								className="accordion-button collapsed"
								type="button"
								data-bs-toggle="collapse"
								data-bs-target="#filter-collapse-4"
								aria-expanded="false"
								aria-controls="filter-collapse-4"
							>
								Event by Topic
							</button>
						</h3>
						<div
							id="filter-collapse-4"
							className="accordion-collapse collapse"
							aria-labelledby="filter-heading-4"
						>
							<div className="accordion-body">
								{props.filters.topics.map(
									(item, index) => (
										<div
											className="form-check"
											key={ item.key }
										>
											<label className="form-check-label">
												<input
													className="form-check-input"
													type="checkbox"
													checked={ item.selected ? true : false }
													value={ item.key }
													onChange={ () => handleFilter('topics', item.key, !item.selected) }
												/>
												{ item.value }
											</label>
										</div>
									)
								)}
							</div>
						</div>
					</div>
				</div>
				<div className="accordion accordion-flush">
					<div className="accordion-item">
						<h3
							className="accordion-header"
							id="filter-heading-5"
						>
							<button
								className="accordion-button collapsed"
								type="button"
								data-bs-toggle="collapse"
								data-bs-target="#filter-collapse-5"
								aria-expanded="false"
								aria-controls="filter-collapse-5"
							>
								Event by Location
							</button>
						</h3>
						<div
							id="filter-collapse-5"
							className="accordion-collapse collapse"
							aria-labelledby="filter-heading-5"
						>
							<div className="accordion-body">
								{props.filters.campuses.map(
									(item, index) => (
										<div
											className="form-check"
											key={ item.key }
										>
											<label className="form-check-label">
												<input
													className="form-check-input"
													type="checkbox"
													checked={ item.selected ? true : false }
													value={ item.key }
													onChange={ () => handleFilter('campuses', item.key, !item.selected) }
												/>
												{ item.value }
											</label>
										</div>
									)
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="footer">
				<button className="clear-all" onClick={ clearAll }>Clear All</button>
				<button className="view-programs" onClick={ props.onClose }>
					View Events
					{props.filtersLoaded ? <span>{` (${props.itemsCount})`}</span> : null}
				</button>
			</div>
		</aside>
	);
}

export default Events;
